import React from "react";
import LiqIntelReport from "./LiqIntelReport";

const LiqIntelGemini: React.FC = () => <LiqIntelReport />;

export default LiqIntelGemini;
